import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import { isSending } from 'actions/composition/lib/in_flight_sends';
import removeComposition from 'actions/composition/lib/remove_composition';

// CloseCurrentComposition only knows the composer's current composition; the panel's draft is
// never current, so it is removed by id. A draft whose send is out stays: removing it would delete
// the uploads the send carries.
export default class DiscardTaskThreadReply {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId }) {
    if (isSending(this.context, compositionId)) {
      return;
    }

    const compositions = getCompositionsStore(this.context);
    const composition = compositions && compositions.findBy({ id: compositionId });
    if (composition) {
      removeComposition(this.context, composition);
    }
  }
}
